import { useMemo } from "react";
import { useIntl } from "react-intl";

import usePermissions from "hooks/usePermissions";
import useSortedPaymentLocations from "hooks/useSortedPaymentLocations";
import { FilterConfig } from "types/Common";

export default function useQuickFilters() {
  const intl = useIntl();
  const { getPaymentLocationLabel } = usePermissions();
  const paymentLocations = useSortedPaymentLocations();

  const QUICK_DISPLAY_STATUS = useMemo(
    () => [
      {
        label: intl.formatMessage({ id: "general.shipping", defaultMessage: "Shipping" }),
        value: "shipping",
      },
      {
        label: intl.formatMessage({ id: "general.processing", defaultMessage: "Processing" }),
        value: "processing",
      },
      {
        label: intl.formatMessage({ id: "general.pending", defaultMessage: "Pending" }),
        value: "pending",
      },
      // {
      //   label: intl.formatMessage({ id: "general.draft", defaultMessage: "Draft" }),
      //   value: "draft",
      // },
      {
        label: intl.formatMessage({ id: "general.archived", defaultMessage: "Archived" }),
        value: "archived",
      },
    ],
    [intl],
  );

  const config: FilterConfig[] = [
    {
      filterType: "multiselect",
      label: intl.formatMessage({ id: "general.displayStatus", defaultMessage: "Display status" }),
      key: "display_status",
      options: QUICK_DISPLAY_STATUS,
    },
    {
      filterType: "multiselect",
      label: getPaymentLocationLabel(),
      key: "payment_location",
      isSearchable: true,
      options: paymentLocations,
    },
    {
      filterType: "accordion",
      label: intl.formatMessage({ id: "general.origin", defaultMessage: "Origin" }),
      key: "origin",
      nestedFilters: [
        {
          filterType: "date",
          label: intl.formatMessage({ id: "general.pickupDate", defaultMessage: "Pickup date" }),
          key: "pickup_date",
        },
        {
          filterType: "text",
          label: intl.formatMessage({ id: "general.pickupCity", defaultMessage: "Pickup city" }),
          key: "pickup_city",
        },
      ],
    },
    {
      filterType: "accordion",
      label: intl.formatMessage({ id: "general.destination", defaultMessage: "Destination" }),
      key: "destination",
      nestedFilters: [
        {
          filterType: "date",
          label: intl.formatMessage({ id: "report.DeliveryDate", defaultMessage: "Delivery date" }),
          key: "delivery_date",
        },
        {
          filterType: "text",
          label: intl.formatMessage({ id: "general.deliveryCity", defaultMessage: "Delivery city" }),
          key: "delivery_city",
        },
      ],
    },
    {
      filterType: "text",
      label: intl.formatMessage({ id: "general.createdBy", defaultMessage: "Created by" }),
      key: "created_by",
    },
  ];

  return { config };
}
